import React, { useState } from 'react';
import { testIPCapture } from '../utils/testIPCapture';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader, FiCheck, FiAlertCircle, FiGlobe, FiRefreshCw } = FiIcons;

const IPCaptureTester = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  
  const runTest = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      const testResult = await testIPCapture();
      setResult(testResult);
    } catch (error) {
      setResult({
        success: false,
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-xl shadow-md">
      <div className="flex items-center justify-center mb-6">
        <SafeIcon icon={FiGlobe} className="text-3xl text-blue-500 mr-2" />
        <h2 className="text-xl font-bold">IP-Erfassung Tester</h2>
      </div>
      
      <p className="text-gray-600 mb-6">
        Dieses Tool testet die IP-Adresserfassung mit externen Diensten (ipify.org und ipapi.co).
        Es zeigt, ob die Erfassung funktioniert und welche IP-Adresse erkannt wird.
      </p>
      
      <button 
        onClick={runTest}
        disabled={loading}
        className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg hover:bg-blue-600 flex items-center justify-center"
      >
        <SafeIcon icon={loading ? FiLoader : FiRefreshCw} className={`mr-2 ${loading ? 'animate-spin' : ''}`} />
        {loading ? 'IP-Adresse wird ermittelt...' : 'IP-Erfassung testen'}
      </button>
      
      {result && (
        <div className={`mt-6 p-4 rounded-lg border ${result.success ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
          <div className="flex">
            <SafeIcon 
              icon={result.success ? FiCheck : FiAlertCircle} 
              className={`mt-1 mr-2 ${result.success ? 'text-green-500' : 'text-red-500'}`} 
            />
            <div>
              <p className={`font-medium ${result.success ? 'text-green-800' : 'text-red-800'}`}>
                {result.success ? 'IP-Adresse erfolgreich ermittelt!' : 'Fehler bei der IP-Ermittlung'}
              </p>
              
              {result.success ? (
                <div className="mt-2">
                  <p className="text-gray-700"><strong>Ihre IP-Adresse:</strong></p>
                  <p className="text-lg font-mono bg-gray-100 p-2 rounded mt-1">{result.ip}</p>
                  <p className="text-sm text-gray-500 mt-2">
                    Diese IP-Adresse wird in der Datenbank gespeichert und dem Admin angezeigt.
                  </p>
                </div>
              ) : (
                <p className="text-red-700 mt-1">{result.error}</p>
              )}
            </div>
          </div>
        </div>
      )}
      
      <div className="mt-6 text-sm text-gray-500">
        <p>Die IP-Erfassung erfolgt über folgende Schritte:</p>
        <ol className="list-decimal pl-5 space-y-1 mt-2">
          <li>Anfrage an ipify.org (primärer Dienst)</li>
          <li>Falls fehlgeschlagen: Anfrage an ipapi.co (Backup-Dienst)</li>
          <li>Speicherung der IP-Adresse in der Datenbank</li>
          <li>Anzeige in den Analytics für Bestellungen</li>
        </ol>
      </div>
    </div>
  );
};

export default IPCaptureTester;